import { FullScreenContent } from "@circle-react/components/Layout/FullScreenLayout/FullScreenContent";
import { FullScreenHeader } from "@circle-react/components/Layout/FullScreenLayout/FullScreenHeader";
import { FullScreenTabs } from "@circle-react/components/Layout/FullScreenLayout/FullScreenTabs";
import { FullScreenTopbar } from "@circle-react/components/Layout/FullScreenLayout/FullScreenTopbar";
import { PageMetaData } from "@circle-react/components/Layout/PageMetaData";
import "./styles.scss";

export interface FullScreenLayoutProps {
  children: React.ReactNode;
  title: string;
}

export const FullScreenLayout = ({
  title,
  children,
}: FullScreenLayoutProps) => (
  <PageMetaData title={title}>
    <div className="react-layout-fullscreen">{children}</div>
  </PageMetaData>
);

FullScreenLayout.Content = FullScreenContent;
FullScreenLayout.Header = FullScreenHeader;
FullScreenLayout.Tabs = FullScreenTabs;
FullScreenLayout.Topbar = FullScreenTopbar;
